import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://us-central1-imagine-bc615.cloudfunctions.net/",  // Firebase Functions URL
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  // Attach the token to request headers
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default axiosInstance;
